// src/deliveryModule/components/RealTime/LiveTripPage.tsx

import React from "react";
import { useParams } from "react-router-dom";
import { Badge, Box, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import LiveDriverMap from "./LiveDriverMap";
import { RootState } from "../../../store/store";
import { useAppSelector } from "../../../store/hooks/hooks";
import { useTripRoom } from "./useTripRoom";
import DriverSimulator from "../DriverSimulator";

const cardsBorderRadii = "8px";

const ENABLE_DRIVER_SIMULATOR =
    process.env.REACT_APP_ENABLE_DRIVER_SIMULATOR === "true";

export default function LiveTripPage() {
    const { deliveryId } = useParams<{ deliveryId: string; }>();

    const delivery = useAppSelector((s: RootState) =>
        s.deliveryRequests.deliveries.find((d: any) => d._id === deliveryId)
    );

    useTripRoom(deliveryId || "");

    if (!deliveryId) return <Text>Missing delivery id.</Text>;
    if (!delivery) return <Text>Loading delivery…</Text>;

    return (
        <Box bg={'#fff'} boxShadow={'md'} m={'30px'} borderRadius={cardsBorderRadii}>
            {/* DELIVERY INFO TABLE */}
            <Box py={6}>
                <Table variant="simple" size="sm">
                    <Tbody>
                        <Tr>
                            <Td fontWeight="bold">From</Td>
                            <Td textAlign="right" color="gray.600">
                                {delivery.pickup.address}
                            </Td>
                        </Tr>

                        <Tr>
                            <Td fontWeight="bold">To</Td>
                            <Td textAlign="right" color="gray.600">
                                {delivery.dropoff.address}
                            </Td>
                        </Tr>

                        <Tr>
                            <Td fontWeight="bold">Status</Td>
                            <Td textAlign="right">
                                <Badge
                                    colorScheme="green"
                                    borderRadius={cardsBorderRadii}
                                    px={3}
                                >
                                    {delivery.status}
                                </Badge>
                            </Td>
                        </Tr>
                    </Tbody>
                </Table>
            </Box>

            {/* Simulator is opt-in for local/test environments only. */}
            {ENABLE_DRIVER_SIMULATOR && (
                <DriverSimulator
                    tripId={delivery._id}
                    pickup={{ lat: delivery.pickup.lat, lng: delivery.pickup.lng }}
                    dropoff={{ lat: delivery.dropoff.lat, lng: delivery.dropoff.lng }}
                />
            )}

            {/* Real Live Map */}
            <LiveDriverMap
                tripId={delivery._id}
                pickup={{ lat: delivery.pickup.lat, lng: delivery.pickup.lng }}
                dropoff={{ lat: delivery.dropoff.lat, lng: delivery.dropoff.lng }}
                pickupAddress={delivery.pickup.address}
                dropoffAddress={delivery.dropoff.address}
                status={delivery.status}
            />
        </Box>
    );
}
